import { render, staticRenderFns } from "./Alliances.vue?vue&type=template&id=bb628a88&scoped=true"
import script from "./Alliances.vue?vue&type=script&lang=js"
export * from "./Alliances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb628a88",
  null
  
)

export default component.exports